/* Handmade Marketplace – shop directory filtering (no apps, no dependencies) */
(function () {
  function init(root) {
    if (root.dataset.hmReady) return;
    root.dataset.hmReady = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hm-card]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.hm-dir__chips [data-hm-filter]'));
    var resetButtons = Array.prototype.slice.call(root.querySelectorAll('[data-hm-empty] [data-hm-filter]'));
    var search = root.querySelector('[data-hm-search]');
    var countEl = root.querySelector('[data-hm-count]');
    var emptyEl = root.querySelector('[data-hm-empty]');
    var featBox = root.querySelector('[data-hm-feat]');
    var featCount = featBox ? featBox.querySelectorAll('[data-hm-strip-card]').length : 0;
    var state = { category: 'all', query: '' };

    function validCategory(c) {
      if (!c) return 'all';
      c = String(c).toLowerCase();
      for (var i = 0; i < buttons.length; i++) if (buttons[i].getAttribute('data-hm-filter') === c) return c;
      return 'all';
    }

    function apply(updateUrl) {
      var q = state.query.trim().toLowerCase();
      var shown = 0;
      // On "All" with no search, the Featured strip is shown at the top. Featured shops are ALSO listed in the
      // main grid, so the grid always holds every matching shop and the count equals the grid cards.
      var stripMode = !!featBox && state.category === 'all' && !q;
      if (featBox) featBox.hidden = !stripMode;
      cards.forEach(function (card) {
        var cats = card.getAttribute('data-categories') || '';
        var text = card.getAttribute('data-search') || '';
        var okCat = state.category === 'all' || cats.indexOf(' ' + state.category + ' ') !== -1;
        var okText = !q || text.indexOf(q) !== -1;
        var show = okCat && okText;
        card.hidden = !show;
        if (show) shown++;
      });
      buttons.forEach(function (b) {
        var active = b.getAttribute('data-hm-filter') === state.category;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' shop' : ' shops');
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (state.category === 'all') url.searchParams.delete('category');
        else url.searchParams.set('category', state.category);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function setCategory(c, updateUrl) {
      state.category = validCategory(c);
      apply(updateUrl);
      var active = root.querySelector('.hm-dir__chips .is-active');
      if (active && active.scrollIntoView && window.matchMedia('(max-width: 749px)').matches) {
        active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    buttons.concat(resetButtons).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.closest('[data-hm-empty]') && search) { search.value = ''; state.query = ''; }
        setCategory(b.getAttribute('data-hm-filter'), true);
      });
    });

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-hm-filter-link]');
      if (!link) return;
      e.preventDefault();
      setCategory(link.getAttribute('data-hm-filter-link'), true);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (search) {
      search.addEventListener('input', function () { state.query = search.value; apply(false); });
    }

    // "Read more" toggles for long descriptions
    root.querySelectorAll('[data-hm-desc]').forEach(function (desc) {
      var btn = desc.parentNode.querySelector('[data-hm-more]');
      if (!btn) return;
      if (desc.scrollHeight > desc.clientHeight + 4) btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        btn.textContent = open ? 'Show less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    var params = new URLSearchParams(window.location.search);
    setCategory(params.get('category'), false);
    var q = params.get('q');
    if (q && search) { search.value = q; state.query = q; apply(false); }
  }

  function boot() { document.querySelectorAll('[data-hm-directory]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
